"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeDisableDragEventPropagation = exports.disableDragEventPropagation = void 0;
const stopPropagation = e => {
  e.stopPropagation();
};
const stopMousedownPropagation = instance => e => {
  if (instance.container === e.target) {
    e.stopPropagation();
  }
};
const disableDragEventPropagation = ({
  instance,
  propagateDragEvent
}) => {
  if (!propagateDragEvent) {
    instance.container.addEventListener('mousedown', stopMousedownPropagation(instance));
    instance.container.addEventListener('mousemove', stopPropagation);
    instance.container.addEventListener('touchmove', stopPropagation);
  }
};
exports.disableDragEventPropagation = disableDragEventPropagation;
const removeDisableDragEventPropagation = ({
  instance,
  propagateDragEvent
}) => {
  if (!propagateDragEvent) {
    instance.container.removeEventListener('mousedown', stopMousedownPropagation(instance));
    instance.container.removeEventListener('mousemove', stopPropagation);
    instance.container.removeEventListener('touchmove', stopPropagation);
  }
};
exports.removeDisableDragEventPropagation = removeDisableDragEventPropagation;
